import { client } from "./axios";
import { PrognosisDto } from "../types/Prognosis";
import { iso8601ToDate } from "../utils/iso8601ToDate";

export const prognosisApi = {
  getAstroPrognosis: async (): Promise<PrognosisDto[]> => {
    const response = await client.post<PrognosisDto[]>("/requestGeneralForecasts");
    const data = response.data.sort((a, b) => (iso8601ToDate(b.endDate ?? "")?.getTime() ?? 0) - (iso8601ToDate(a.endDate ?? "")?.getTime() ?? 0));
    return data;
  },
  getZodiacPrognosis: async (): Promise<PrognosisDto[]> => {
    const response = await client.get<PrognosisDto[]>("/v2/requestPersonalForecasts");
    const data = response.data.sort((a, b) => (iso8601ToDate(b.endDate ?? "")?.getTime() ?? 0) - (iso8601ToDate(a.endDate ?? "")?.getTime() ?? 0));
    return data;
  },

  getYearPrognosis: async (): Promise<PrognosisDto> => {
    const response = await client.get<PrognosisDto>("/v2/requestYearForecasts");
    const data = response.data;
    return data;
  },
};
